<ion-menu side="end" type="overlay" contentId="main-content" menu-id="side" swipe-gesture="false"
  class="border-l border-white/10">
  <ion-content class="bg-white">
    <div class="flex h-full flex-col">
      <!-- Header -->
      <div class="p-5 pb-2">
        <h2 class="text-xl font-black tracking-tight text-brand-dark">Menu</h2>
        <p class="text-xs text-gray-500">Story Lounge</p>
      </div>

      <!-- Navigation -->
      <nav class="flex-1 space-y-1 px-3 py-2">
        <button (click)="navigateTo('/accueil')"
          class="flex w-full items-center gap-3 rounded-xl px-3 py-3 text-gray-700 transition-all hover:bg-gray-100 active:scale-95">
          <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-primary/10 text-brand-primary">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
          </div>
          <span class="text-sm font-bold">Accueil</span>
        </button>

        <div class="py-1">
          <div class="px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-gray-400">Réseaux sociaux</div>

          <button (click)="openSocialInNavigator('instagram')"
            class="flex w-full items-center gap-3 rounded-xl px-3 py-3 text-gray-700 transition-all hover:bg-gray-100 active:scale-95">
            <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-primary/10 text-brand-primary">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.266.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </div>
            <span class="text-sm font-bold">Instagram</span>
          </button>

          <button (click)="openSocialInNavigator('facebook')"
            class="flex w-full items-center gap-3 rounded-xl px-3 py-3 text-gray-700 transition-all hover:bg-gray-100 active:scale-95">
            <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-primary/10 text-brand-primary">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </div>
            <span class="text-sm font-bold">Facebook</span>
          </button>

          <button (click)="openSocialInNavigator('tiktok')"
            class="flex w-full items-center gap-3 rounded-xl px-3 py-3 text-gray-700 transition-all hover:bg-gray-100 active:scale-95">
            <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-primary/10 text-brand-primary">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M12.536 0.03c1.282-0.02 2.562-0.01 3.843-0.02 0.078 1.503 0.619 3.035 1.719 4.093 1.096 1.082 2.646 1.59 4.153 1.751v3.951c-1.408-0.051-2.829-0.347-4.113-0.957-0.558-0.264-1.077-0.584-1.583-0.916-0.012 2.858 0.012 5.716-0.018 8.572-0.082 1.373-0.531 2.729-1.324 3.858-1.283 1.879-3.504 3.102-5.787 3.141-1.402 0.08-2.805-0.31-3.996-1.012-1.977-1.168-3.364-3.302-3.57-5.59-0.018-0.501-0.027-1.002-0.007-1.504 0.178-1.859 1.099-3.64 2.528-4.858 1.624-1.406 3.896-2.083 6.023-1.688 0.016 1.455-0.033 2.909-0.033 4.364-0.975-0.315-2.106-0.223-2.956 0.364-0.617 0.407-1.086 1.018-1.334 1.718-0.203 0.5-0.147 1.045-0.134 1.574 0.231 1.61 1.785 2.955 3.427 2.809 1.101-0.01 2.149-0.638 2.716-1.579 0.187-0.323 0.392-0.655 0.402-1.04 0.101-1.758 0.063-3.518 0.07-5.277 0.012-3.944-0.012-7.889 0.024-11.833z" />
              </svg>
            </div>
            <span class="text-sm font-bold">TikTok</span>
          </button>
        </div>

        <div class="py-1">
          <div class="px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-gray-400">Contact & Adresse</div>

          <div class="flex flex-col gap-1 py-2">
            <a href="tel:+21627200075"
              class="flex w-full items-center gap-3 rounded-xl px-3 py-3 text-gray-700 transition-all hover:bg-gray-100 active:scale-95">
              <div class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-brand-primary/10 text-brand-primary">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <span class="text-sm font-bold">27 200 075</span>
            </a>

            <a href="https://maps.app.goo.gl/2GRTZxVednESCc5F6" target="_blank" rel="noopener noreferrer"
              class="flex w-full items-center gap-3 rounded-xl px-3 py-3 text-gray-700 cursor-pointer hover:bg-gray-100 transition-all active:scale-95">
              <div
                class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-brand-primary/10 text-brand-primary">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <span class="text-sm font-bold">Voir sur Google Maps</span>
            </a>
          </div>
        </div>
      </nav>

      <!-- Reserve Button -->
      <div class="px-6 pb-3">
        <a href="tel:+21627200075" class="reserve-btn">
          <span class="reserve-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.01-.24c1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
            </svg>
          </span>
          <span class="reserve-text">Réservez une Table</span>
        </a>
      </div>

      <!-- Footer -->
      <div class="border-t border-gray-100 p-4">
        <p class="text-center text-xs text-gray-400">© 2026 Story Lounge</p>
        <p class="text-center text-[10px] text-gray-300 mt-1">by scanini</p>
      </div>
    </div>
  </ion-content>
</ion-menu>